exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".maintenance-plan-item-name{font-size:1.8rem;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/details/components/maintenance-plan-item.scss
// module id = 5112
// module chunks = 0